import React from 'react';
// import d3 from 'd3';

import LinechartMultiple from '../lineChartMultiple/LinechartMultiple.component';

import {timeParse,timeFormat} from 'd3-time-format';
import {scaleLinear, scaleOrdinal, scaleTime} from 'd3-scale';
import {line} from 'd3-shape';
import {extent, max, mean, median} from 'd3-array';
import {select as d3select} from 'd3-selection';
import {axisBottom as d3axisBottom, axisLeft as d3axisLeft} from 'd3-axis';
import {formatDefaultLocale,format} from 'd3-format';
import {interpolate} from 'd3-interpolate';
import {keys, nest} from 'd3-collection';

require('ta-semantic-ui/semantic/dist/components/button.css');

const dataSource = require('json!../multipleLineChart/data/data.json');

/************************************************************************/

class MultipleLineChart extends React.Component {

  basicDataByYear = [];
  marriedDataByYear = [];

  constructor(props) {
    super(props);

    this.changeData = this.changeData.bind(this);

    const dataByCategory = nest()
      .key(function (d) {
        return d.SteuerTariflang
      })
      .key(function (d) {
        return d.SteurJahr
      })
      .entries(dataSource);

    for(let i=0; i<dataByCategory[0]['values'][0]['values'].length; i++) {
      this.basicDataByYear.push({
        year: dataByCategory[0]['values'][0]['values'][i]['SteuerJahr'],
        p25: dataByCategory[0]['values'][0]['values'][i]['p25'],
        p50: dataByCategory[0]['values'][0]['values'][i]['p50'],
        p75: dataByCategory[0]['values'][0]['values'][i]['p75']
      })
    }

    for(let i=0; i<dataByCategory[1]['values'][0]['values'].length; i++) {
      this.marriedDataByYear.push({
        year: dataByCategory[1]['values'][0]['values'][i]['SteuerJahr'],
        p25: dataByCategory[1]['values'][0]['values'][i]['p25'],
        p50: dataByCategory[1]['values'][0]['values'][i]['p50'],
        p75: dataByCategory[1]['values'][0]['values'][i]['p75']
      })
    }

    /* Set data states */
    this.state = {
      actualDataSource: this.basicDataByYear,
      activeButton: 'basic'
    };

  }

  changeData(e) {
    let newDataSource = e.currentTarget.getAttribute('data-selector');
    // console.log(newDataSource);
    if(newDataSource == 'basic') {
      this.setState({
        actualDataSource: this.basicDataByYear,
        activeButton: 'basic'
      })
    } else {
      this.setState({
        actualDataSource: this.marriedDataByYear,
        activeButton: 'married'
      })
    }
    // console.log(this.state.actualDataSource)
  }

  render() {

    return(

      <div
        className={`ui  dimmable ${this.props.readerMadeHisChoice ? '' : 'dimmed'} segment padded linechart`}
      >

        <div
          className='ui inverted simple dimmer'
          style={{
            display: this.state.readerMadeHisChoice ? 'none' : 'block'
          }}
        >
        </div>


        <div style={{maxWidth: '640px', margin: '0 auto', marginTop: '30px', marginBottom: '40px'}}>
          <h3
            style={{
              marginBottom: '10px',
              fontFamily: 'Benton Sans Cond',
              fontWeight: 'bold'
            }}
          >
            Entwicklung des steuerbaren Einkommens</h3>
          <p
            style={{
              marginBottom: '20px'
            }}
          >Indexierte Werte, aufgeteilt in das&nbsp;
            <span
              className='round-number'
              style={{
                fontSize: '17px',
                background: '#E23C4E',
                borderRadius: '50%',
                color: 'white',
                padding: '4px',
                paddingLeft: '6px'
              }}
            >
            25.
          </span>, das <span
              className='round-number'
              style={{
                fontSize: '17px',
                background: '#1D5F82',
                borderRadius: '50%',
                color: 'white',
                padding: '4px',
                paddingLeft: '6px'
              }}
            >
            50.
          </span> und das <span
              className='round-number'
              style={{
                fontSize: '17px',
                background: '#000',
                borderRadius: '50%',
                color: 'white',
                padding: '4px',
                paddingLeft: '6px'
              }}
            >
            75.
          </span>

            &nbsp;Perzentil für die Stadt Zürich.</p>

          <div
            className='button-wrapper'
            style={{textAlign: 'center'}}
          >
            <div className='ui small buttons'>
              <button
                className={`ui button ${this.state.activeButton == 'basic' ? 'active' : ''}`}
                data-selector='basic'
                onClick={this.changeData}
              >
                Ledige
              </button>
              <div
                className=''
              ></div>
              <button
                className={`ui button ${this.state.activeButton == 'married' ? 'active' : ''}`}
                data-selector='married'
                onClick={this.changeData}
              >
                Verheiratete
              </button>
            </div>
          </div>

          <div
            className='linechart-wrapper large'
            style={{
              maxWidth: '640px'
            }}
          >
            <LinechartMultiple
              chartClassName='large'
              chartTitle=''
              width={this.props.width}
              height={
                this.props.width > 450 ? 480 : 420
              }
              chartId='multiple-lines-chart'
              readerIsCityCitizen={this.props.readerIsCityCitizen}
              readerMadeHisChoice={this.props.readerMadeHisChoice}
              circleRadius={4}
              circleFillp25='#E23C4E'
              circleFillp50='#000000'
              circleFillp75='#1D5F82'
              circleStroke={1}
              circleStrokeFill='#ffffff'
              circleStrokeFillp25='#E23C4E'
              circleStrokeFillp50='#000000'
              circleStrokeFillp75='#1D5F82'
              ticksX={10}
              ticksY={10}
              minY={100}
              maxY={135}
              tickFormatX='%Y'
              linechartClass='large'
              tooltipHeight={50}
              tooltipWidth={90}
              tooltipFontSize={14}
              dataSource={this.state.actualDataSource}
            />
          </div>

        </div>
      </div>

    )

  }

}

MultipleLineChart.propTypes = {

  readerMadeHisChoice: React.PropTypes.bool,
  readerIsCityCitizen: React.PropTypes.bool,
  width: React.PropTypes.number,
  height: React.PropTypes.number

}

export default MultipleLineChart;








// WEBPACK FOOTER //
// ./src/components/multipleLineChart/MultipleLineChart.js